module.exports = __webpack_public_path__ + "img/l2-bird.5c01c858.png";